<div class="surface-card p-5 m-3 shadow-1 border-round">
  <div class="font-medium text-2xl text-700 mb-3">Método de Pago</div>
  <div
    *ngFor="let payment of typesPayment"
    class="hover:bg-primary p-field-checkbox surface-border border-1 p-3 cursor-pointer surface-card"
  >
    <p-radioButton
      class="p-element ng-untouched ng-pristine ng-valid"
      [inputId]="payment.id"
      name="payment"
      [value]="payment"
      [(ngModel)]="selectedPayment"
      (onClick)="onSelectPayment(payment)"
    ></p-radioButton>
    <label [for]="payment.id" class="ml-2 text-xl font-medium">
      <i [class]="payment.icon"> </i>
      {{ payment.name }}
    </label>
  </div>
</div>
